// Translations for the Users (admin user management) page.
const usersDict = [
  { en: "Access denied", sw: "Ufikiaji umekataliwa" },
  { en: "Loading...", sw: "Inapakia..." },
  { en: "ID", sw: "Kitambulisho" },
  { en: "Email", sw: "Barua pepe" },
  { en: "Role ID", sw: "Kitambulisho cha Jukumu" },
  { en: "Actions", sw: "Vitendo" },
  { en: "Create User", sw: "Unda Mtumiaji" },
  { en: "Password", sw: "Nenosiri" },
  { en: "Create", sw: "Tengeneza" },
];

export default usersDict;
